import { render, staticRenderFns } from "./LiveAgents.vue?vue&type=template&id=533bf5c4&"
import script from "./LiveAgents.vue?vue&type=script&lang=js&"
export * from "./LiveAgents.vue?vue&type=script&lang=js&"
import style0 from "./LiveAgents.vue?vue&type=style&index=0&id=533bf5c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports